module.exports = __webpack_public_path__ + "img/index-view.63216fbb.png";